import * as React from "react";
const SvgFiRrFaceFearful = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-fearful_svg__a)">
      <path
        fill="#062147"
        d="M18.92 8.982c.028.002.053.018.081.018a1 1 0 0 0 .781-1.623c-.91-1.143-2.308-2.065-3.56-2.352a.998.998 0 1 0-.445 1.949c.698.16 1.523.691 2.143 1.333a3.5 3.5 0 0 0-1.42-.308c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5c0-.99-.417-1.881-1.08-2.518zM16.5 13c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5M11 11.5C11 9.57 9.43 8 7.5 8a3.5 3.5 0 0 0-1.42.308c.619-.642 1.445-1.173 2.143-1.333a.999.999 0 1 0-.445-1.949c-1.252.286-2.649 1.209-3.56 2.352a1 1 0 0 0 .781 1.623c.028 0 .053-.016.081-.018A3.48 3.48 0 0 0 4 11.501c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5zM7.5 13c-.827 0-1.5-.673-1.5-1.5S6.673 10 7.5 10s1.5.673 1.5 1.5S8.327 13 7.5 13M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m2.965-3.776c.13.382-.173.775-.576.775H9.601c-.405 0-.707-.397-.573-.78.375-1.072 1.532-2.22 2.972-2.22s2.6 1.15 2.965 2.224z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-fearful_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceFearful;
